import { MeetingModel } from '../../models/meetingModel/MeetingModel';
import { agendaResponse } from '../../models/agendaModel/agendaResponse';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs';
import { TranscriptionResponse } from 'src/app/Models/transcriptionModelR/transcription-response';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {

 //private base = environment2.baseUrl + '/api/';
  private base = environment.urlServerApi;
  private agen = environment.urlAgendaApi;

  constructor(private _http: HttpClient) {
  }
//AWTDBE02\AWTDBE02INST1,54901 username: secsqltest pass:Consultant#10Test
//downloadDocument(documentId): Observable<any> {
  //const idToken = localStorage.getItem("idToken");
  //const requestOptions: Object = { headers: new HttpHeaders().append('Authorization', 'Bearer '+ idToken), responseType: 'blob'    }
  //const url = `${this.base}documents/${documentId}/download`;
  //return this._http.get<any>(url,requestOptions);
//}

  getTranscriptionMeeting(IdMeet, published) : Observable<TranscriptionResponse> {
    return this._http.get<TranscriptionResponse>(`${this.base}transcriptions/meetings?meetingId=${IdMeet}&published=${published}`);
  }  
}
